export default __webpack_public_path__ + "static/media/z670ma0a.b3938222.mp3";